import dayjs from "dayjs";

export const getWalletsTableColumns = (enableBases) => [
  {
    title: "Cod Contacto",
    dataIndex: "codContact",
    key: "codContact",
    width: "160px",
    slots: { customRender: "codContact" },
    code: "code_contact",
  },
  {
    title: "Nombres y Apellidos",
    dataIndex: "fullName",
    key: "fullName",
    width: "340px",
    // ellipsis: true,
    slots: { customRender: "fullName" },
    code: "fullname",
  },
  {
    title: "Estado(s)",
    dataIndex: "status",
    key: "status",
    width: "230px",
    slots: { customRender: "status" },
    code: "status",
  },
  {
    title: "Empresa",
    dataIndex: "entityName",
    key: "entityName",
    width: "230px",
    code: "entity_name",
  },
  {
    title: "Campaña",
    dataIndex: "portfolioName",
    key: "portfolioName",
    width: "240px",
    code: "portfolio_name",
  },
  // {
  //   title: "Bases",
  //   dataIndex: "baseName",
  //   key: "baseName",
  //   width: "240px",
  //   slots: { title: "titleBases", customRender: "baseName" },
  // },
  ...(enableBases
    ? [
        {
          title: "Nombre",
          dataIndex: "baseName",
          key: "baseName",
          width: "240px",
          slots: { title: "titleBases", customRender: "baseName" },
          // code: "fullname",
        },
      ]
    : []),
  {
    title: "Teléfono",
    dataIndex: "phones",
    key: "phones",
    width: 120,
    slots: { customRender: "phones" },
    code: "phone_contact",
  },
  {
    title: "Productos",
    dataIndex: "total_accounts",
    key: "total_accounts",
    width: 120,
    slots: { customRender: "total_accounts" },
    code: "products",
  },
  {
    title: "Correo",
    dataIndex: "emails",
    key: "emails",
    width: 120,
    slots: { customRender: "emails" },
    code: "email",
  },
  {
    title: "Número de Documento",
    dataIndex: "documentNumber",
    key: "documentNumber",
    width: "240px",
    code: "document_number",
  },
  {
    title: "Canales",
    dataIndex: "channels",
    key: "channels",
    width: "240px",
    slots: { customRender: "channels" },
    code: "channels",
  },
  {
    title: "Nombre de la secuencia",
    dataIndex: "sequence_name",
    key: " sequence_name",
    width: "240px",
    slots: { customRender: "sequence_name" },
    code: "sequence_name",
  },
  {
    title: "Estado de la secuencia",
    dataIndex: "sequence_status",
    key: " sequence_status",
    width: "240px",
    slots: { customRender: "sequence_status" },
    code: "sequence_status",
  },
  {
    title: "Estado del contacto en la secuencia",
    dataIndex: "state_in_sequence",
    key: " state_in_sequence",
    width: "240px",
    slots: { customRender: "state_in_sequence" },
    code: "state_in_sequence",
  },
  {
    title: "Fecha de última gestión",
    dataIndex: "lastManagementDate",
    key: "lastManagementDate",
    width: "250px",
    sorter: (a, b) => {
      if (a.lastManagementDate < b.lastManagementDate) return -1;
      if (a.lastManagementDate > b.lastManagementDate) return 1;
      return 0;
    },
    slots: { customRender: "lastManagementDate", title: "customTitleLastManagementDate" },
    code: "last_date_management",
  },
  {
    title: "Fecha de última interacción",
    dataIndex: "lastInteractionDate",
    key: "lastInteractionDate",
    width: "250px",
    sorter: (a, b) => {
      if (a.lastInteractionDate < b.lastInteractionDate) return -1;
      if (a.lastInteractionDate > b.lastInteractionDate) return 1;
      return 0;
    },
    slots: { title: "titleLastInteractionDate", customRender: "lastInteractionDate" },
    code: "last_date_interaction",
  },
  {
    title: "Mejor grupo del mes",
    dataIndex: "bestManagementGroupMonth",
    key: "bestManagementGroupMonth",
    width: "240px",
    ellipsis: true,
    code: "best_group",
  },
  {
    title: "Mejor resultado del mes",
    dataIndex: "bestManagementResultMonth",
    key: "bestManagementResultMonth",
    width: "240px",
    slots: { customRender: "bestResultMonth" },
    ellipsis: true,
    code: "best_result",
  },
  {
    title: "Mejor motivo del mes",
    dataIndex: "bestManagementMotiveMonth",
    key: "bestManagementMotiveMonth",
    width: "240px",
    ellipsis: true,
    code: "best_motive",
  },
  {
    title: "Mejor submotivo del mes",
    dataIndex: "bestManagementSubmotiveMonth",
    key: "bestManagementSubmotiveMonth",
    width: "240px",
    ellipsis: true,
    code: "best_sub_motive",
  },
  {
    title: "Último grupo",
    dataIndex: "lastGroup",
    key: "lastGroup",
    width: "240px",
    ellipsis: true,
    code: "last_group",
  },
  {
    title: "Último resultado",
    dataIndex: "lastResult",
    key: "lastResult",
    width: "240px",
    ellipsis: true,
    code: "last_result",
  },
  {
    title: "Último motivo",
    dataIndex: "lastMotive",
    key: "lastMotive",
    width: "240px",
    ellipsis: true,
    code: "last_motive",
  },
  {
    title: "Último submotivo",
    dataIndex: "lastSubmotive",
    key: "lastSubmotive",
    width: "240px",
    ellipsis: true,
    code: "last_sub_motive",
  },
  {
    title: "Última vez gestionado por:",
    dataIndex: "lastManagementUser",
    key: "lastManagementUser",
    width: "240px",
    ellipsis: true,
    code: "last_user_managed",
  },
  {
    title: "Usuario asignado:",
    dataIndex: "user_assigned",
    key: "user_assigned",
    width: "240px",
    ellipsis: true,
    code: "assigned_user",
  },
  {
    title: "Fecha de creación",
    dataIndex: "created_at",
    key: "created_at",
    width: "200px",
    customRender: ({ text }) => (text ? dayjs(text).format("DD/MM/YYYY") : "-"),
    sorter: (a, b) => {
      const first = dayjs(a.created_at);
      const second = dayjs(b.created_at);

      return first.subtract(second);
    },
    code: "date_created",
  },
  {
    title: "Fecha de última actualización",
    dataIndex: "updated_at",
    key: "updated_at",
    width: "240px",
    customRender: ({ text }) => (text ? dayjs(text).format("DD/MM/YYYY") : "-"),
    sorter: (a, b) => {
      const first = dayjs(a.updated_at);
      const second = dayjs(b.updated_at);

      return first.subtract(second);
    },
    code: "last_update_date",
  },
  {
    title: "Nombre de usuario en WhatsApp",
    dataIndex: "whatsapp_username",
    key: "whatsapp_username",
    width: "260px",
    slots: { customRender: "whatsappUsername" },
    code: "whatsapp_username",
  },
  {
    title: "Identificador de WhatsApp",
    dataIndex: "whatsapp_user_id",
    key: "whatsapp_user_id",
    width: "260px",
    slots: { customRender: "whatsappUserId" },
    code: "whatsapp_user_id",
  },
  {
    title: "Acciones",
    key: "actions",
    dataIndex: "actions",
    fixed: "right",
    width: 150,
    slots: { customRender: "actions" },
    code: "actions",
  },
];
